import type { BlokProps } from "@trydig/storyblok";
import { clsx } from "@trydig/ui";
import BlokWrap from "@/components/bloks/BlokWrap";
import { RichTextRenderer } from "@/components/ui/RichText";
import { Link } from "@/i18n/routing";
import { sbLink } from "@/lib/storyblok/link";
import type { BlokCampaignCard } from "@/storyblok";
import { AssetBlok, multiAssetToSingleAsset, sizes } from "../Asset";
import styles from "./CampaignCardBlok.module.css";

export const CampaignCardBlok = ({
	blok,
	preview,
	"data-priority": priority,
	...rest
}: BlokProps<BlokCampaignCard> & {
	"data-priority"?: boolean;
}) => {
	const reverse = blok.reverse ?? false;
	const href = blok.link ? sbLink(blok.link)?.href : undefined;
	const asymmetric = blok.asymmetricLayout ?? false;

	return (
		<BlokWrap
			editable={blok}
			as="div"
			{...rest}
			className={clsx(
				styles.root,
				reverse && styles.reverse,
				asymmetric && styles.asymmetricMobile,
			)}
		>
			<div className={styles.background} />
			<div className={styles.mediaWrap}>
				<div className={styles.media}>
					<AssetBlok
						source={multiAssetToSingleAsset(blok.media!)}
						muted
						autoPlay
						loop
						priority={priority}
						quality={90}
						sizes={sizes(90, 50)}
					/>
				</div>
			</div>
			<div className={styles.textWrap}>
				<div className={styles.text}>
					{blok.title && <h2 className={styles.title}>{blok.title}</h2>}

					{blok.description && (
						<div className={styles.description}>
							<RichTextRenderer blok={blok.description!} preview={preview} />
						</div>
					)}

					{href && (
						<Link
							href={href}
							className={styles.link}
							aria-label={`Read more about ${blok.title}`}
						>
							{blok.linkText}
						</Link>
					)}
				</div>
			</div>
		</BlokWrap>
	);
};
